(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* === ODDAY additions: hover-open mega menu + inject image cards === */
  (function () {
    function init() {
      var header = document.querySelector('.section-header');
      if (!header) return;

      /* Collection front-image map emitted by Liquid (url → image src). */
      var megaImages = {};
      var imagesEl = header.querySelector('[data-odday-mega-images]');
      if (imagesEl) {
        try { megaImages = JSON.parse(imagesEl.textContent || '{}') || {}; }
        catch (e) { megaImages = {}; }
      }

      /* --- 0. Transparent-at-top → solid-on-scroll toggle ---
         Independent of StickyHeader's scrolled-past-header (which only
         fires once you've scrolled past the entire header). We want the
         switch to happen within the first few pixels.

         Also publishes --header-height ourselves so the overlay's negative
         margin-bottom is always correct — StickyHeader only sets it when
         sticky_header_type != 'none', and even then the value is stale
         after viewport/font-load changes until a resize handler fires. */
      var overlay = header.querySelector('.odday-header-overlay');
      if (overlay) {
        var publishHeight = function () {
          var h = overlay.offsetHeight;
          if (h) document.documentElement.style.setProperty('--header-height', h + 'px');
        };
        publishHeight();
        /* offsetHeight before fonts/logo image load is often short; re-measure
           after load and any time the header element itself resizes. */
        window.addEventListener('load', publishHeight);
        window.addEventListener('resize', publishHeight);
        if ('ResizeObserver' in window) {
          new ResizeObserver(publishHeight).observe(overlay);
        }

        var lastScrolled = null;
        var onScrollSolid = function () {
          var st = window.pageYOffset || document.documentElement.scrollTop;
          var scrolled = st > 16;
          if (scrolled !== lastScrolled) {
            header.classList.toggle('is-scrolled', scrolled);
            lastScrolled = scrolled;
          }
        };
        onScrollSolid();
        window.addEventListener('scroll', onScrollSolid, { passive: true });
      }

      /* --- 1. Hover-to-open behavior for mega menus ---
         The mega panel is position:absolute, so it sits outside header-menu's
         bounding box. Element-level mouseleave/mouseenter races the cursor as
         it crosses the gap. Use document-level mouseover/mouseout with
         closest() instead — that checks DOM ancestry, not visual layout, so
         the trigger and its panel act as one continuous hover region. */
      var headerMenus = header.querySelectorAll('header-menu');
      var hoverTimer = null;
      var CLOSE_DELAY = 400;
      /* Include .header-wrapper so the empty padding inside the header bar
         and the gap between nav items still count as "on the menu." Without
         this, the cursor passing through that empty area on its way to the
         panel triggers a close before the click can land. */
      var MENU_SELECTOR = 'header-menu, .header-wrapper, .mega-menu__content, .header__submenu';

      function closeAllMenus() {
        headerMenus.forEach(function (hm) {
          var d = hm.querySelector('details');
          if (d && d.open) d.removeAttribute('open');
        });
        hoverTimer = null;
      }

      function openMenu(hm) {
        var details = hm.querySelector('details');
        if (!details) return;
        headerMenus.forEach(function (other) {
          if (other === hm) return;
          var od = other.querySelector('details');
          if (od && od.open) od.removeAttribute('open');
        });
        if (!details.open) details.setAttribute('open', '');
      }

      headerMenus.forEach(function (hm) {
        hm.addEventListener('mouseenter', function () {
          clearTimeout(hoverTimer);
          hoverTimer = null;
          openMenu(hm);
        });
      });

      /* Any hover inside a trigger or panel — cancel the pending close. */
      document.addEventListener('mouseover', function (e) {
        if (!e.target || !e.target.closest) return;
        if (e.target.closest(MENU_SELECTOR)) {
          clearTimeout(hoverTimer);
          hoverTimer = null;
        }
      });

      /* Leaving for an element outside both the trigger and the panel —
         schedule close. relatedTarget is null when leaving the window. */
      document.addEventListener('mouseout', function (e) {
        if (!e.target || !e.target.closest) return;
        if (!e.target.closest(MENU_SELECTOR)) return;
        var to = e.relatedTarget;
        if (to && to.closest && to.closest(MENU_SELECTOR)) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(closeAllMenus, CLOSE_DELAY);
      });

      /* --- 2. Inject mega-card templates into the matching mega menu panel --- */
      var templates = header.querySelectorAll('.odday-mega-card-tpl');
      if (templates.length) {
        var groups = {};
        templates.forEach(function (tpl) {
          var key = (tpl.dataset.parent || '').trim().toLowerCase();
          if (!key) return;
          if (!groups[key]) groups[key] = [];
          groups[key].push(tpl.content.cloneNode(true));
        });

        headerMenus.forEach(function (hm) {
          var summary = hm.querySelector('summary');
          if (!summary) return;
          var title = (summary.textContent || '').trim().toLowerCase();
          var cards = groups[title];
          if (!cards || !cards.length) return;
          var list = hm.querySelector('.mega-menu__list');
          if (!list) return;
          if (list.querySelector('.odday-mega-cards-item')) return;
          var li = document.createElement('li');
          li.className = 'odday-mega-cards-item';
          var cardsWrap = document.createElement('div');
          cardsWrap.className = 'odday-mega-cards odday-mega-cards--' + Math.min(cards.length, 3);
          cards.forEach(function (frag) { cardsWrap.appendChild(frag); });
          li.appendChild(cardsWrap);
          list.appendChild(li);
        });
      }

      /* --- 3. BLUORNG-style collection cards ---
         Replace each mega panel's plain text link list with a horizontal row
         of image cards: the collection's front image (rounded) + name below.
         Image comes from the url→image map emitted by Liquid. */
      headerMenus.forEach(function (hm) {
        var content = hm.querySelector('.mega-menu__content');
        if (!content) return;
        if (content.querySelector('.odday-mega-collections')) return;
        var list = content.querySelector('.mega-menu__list');
        if (!list) return;

        var anchors = Array.prototype.slice.call(list.querySelectorAll('a.mega-menu__link'));
        if (!anchors.length) return;

        var row = document.createElement('div');
        row.className = 'odday-mega-collections page-width';

        anchors.forEach(function (a) {
          var href = a.getAttribute('href');
          var src = href ? megaImages[href] : null;
          var name = (a.textContent || '').trim();

          var card = document.createElement('a');
          card.className = 'odday-collection-card';
          card.href = href || '#';
          /* Keep clicks from being swallowed by Dawn's summary delegation. */
          card.addEventListener('click', function (e) { e.stopPropagation(); });

          var media = document.createElement('span');
          media.className = 'odday-collection-card__media';
          if (src) {
            var im = document.createElement('img');
            im.src = src;
            im.alt = name;
            im.loading = 'lazy';
            media.appendChild(im);
          }
          card.appendChild(media);

          var label = document.createElement('span');
          label.className = 'odday-collection-card__name';
          label.textContent = name;
          card.appendChild(label);

          row.appendChild(card);
        });

        content.appendChild(row);
        content.classList.add('has-odday-collections');
      });

      /* --- 3b. Mobile drawer: "About Us" link + collection image row ---
         Dawn's menu-drawer markup isn't rendered by this section, so it can
         only be enhanced from JS. The drawer exists in the DOM at all times
         (just hidden until opened), so we can find and augment it here. */
      (function () {
        var drawer = document.querySelector('.menu-drawer');
        if (!drawer) return;

        /* (a) Insert the "About Us" link as the first line of the drawer's
           utility row, so it sits directly above the Log in link. */
        var aboutTpl = header.querySelector('[data-odday-drawer-about]');
        if (aboutTpl && !drawer.querySelector('.odday-drawer-about')) {
          var utility = drawer.querySelector('.menu-drawer__utility-links');
          if (utility) {
            utility.insertBefore(aboutTpl.content.cloneNode(true), utility.firstChild);
          }
        }

        /* (b) Append a horizontal image row to the bottom of each submenu,
           built ONLY from "Mega menu image card" blocks whose "Show under
           menu link" matches the submenu's parent title (e.g. Shop). No
           collection images are used. Gated by the drawer-config flag (this
           script block is not Liquid-rendered). */
        var drawerCfg = {};
        var drawerCfgEl = header.querySelector('[data-odday-drawer-config]');
        if (drawerCfgEl) {
          try { drawerCfg = JSON.parse(drawerCfgEl.textContent || '{}') || {}; }
          catch (e) { drawerCfg = {}; }
        }

        /* Mega-card blocks grouped by their parent menu title. */
        var megaCardTpls = header.querySelectorAll('.odday-mega-card-tpl');
        function cardsForParent(title) {
          var out = [];
          megaCardTpls.forEach(function (tpl) {
            if ((tpl.dataset.parent || '').trim().toLowerCase() !== title) return;
            var img = tpl.content.querySelector('img');
            if (!img || !img.getAttribute('src')) return; /* needs an image */
            var t = tpl.content.querySelector('.odday-mega-card__title');
            var a = tpl.content.querySelector('a');
            out.push({
              src: img.getAttribute('src'),
              name: t ? (t.textContent || '').trim() : '',
              href: a ? (a.getAttribute('href') || '#') : '#'
            });
          });
          return out;
        }

        if (drawerCfg.collectionImages) {
          var submenus = drawer.querySelectorAll('.menu-drawer__submenu');
          submenus.forEach(function (submenu) {
            if (submenu.querySelector('.odday-drawer-collections')) return;
            /* Append to the submenu's CONTENT wrapper (where the back button +
               link list live), not the positioned .menu-drawer__submenu slide
               container — otherwise the row can render off-screen. Dawn names
               this wrapper differently across versions, so try each; finally
               fall back to placing the row right after the link list. */
            var listEl = submenu.querySelector('.menu-drawer__menu');
            var container = submenu.querySelector('.menu-drawer__inner-submenu')
              || submenu.querySelector('.menu-drawer__navigation')
              || (listEl && listEl.parentNode)
              || submenu;

            /* Parent menu title (e.g. "Shop") from the enclosing <details>. */
            var det = submenu.closest('details');
            var parentSummary = det ? det.querySelector('summary') : null;
            var parentTitle = parentSummary ? (parentSummary.textContent || '').trim().toLowerCase() : '';

            var cards = cardsForParent(parentTitle);
            if (!cards.length) return;

            var grid = document.createElement('ul');
            grid.className = 'odday-drawer-collections';

            cards.forEach(function (c) {
              var li = document.createElement('li');
              li.className = 'odday-drawer-collection-card';
              var card = document.createElement('a');
              card.className = 'odday-drawer-collection-card';
              card.href = c.href || '#';

              var media = document.createElement('span');
              media.className = 'odday-drawer-collection-card__media';
              var im = document.createElement('img');
              im.src = c.src;
              im.alt = c.name;
              im.loading = 'lazy';
              media.appendChild(im);
              card.appendChild(media);

              if (c.name) {
                var label = document.createElement('span');
                label.className = 'odday-drawer-collection-card__name';
                label.textContent = c.name;
                card.appendChild(label);
              }

              li.appendChild(card);
              grid.appendChild(li);
            });

            container.appendChild(grid);
          });
        }
      })();

      /* --- 4. Outfit ideas story viewer ---
         Hooked off the trigger button + modal markup added by Liquid.
         Auto-advance is driven by the same CSS animation that fills the
         progress segment, so visual state and timing are guaranteed in
         sync — no separate JS timer that can drift. */
      var storiesModal = header.querySelector('[data-odday-stories]');
      var storiesTrigger = header.querySelector('[data-odday-stories-open]');
      if (storiesModal && storiesTrigger && !storiesModal.dataset.bound) {
        storiesModal.dataset.bound = '1';
        var slides = Array.from(storiesModal.querySelectorAll('[data-stories-slide]'));
        var progressWrap = storiesModal.querySelector('[data-stories-progress]');
        var prevBtns = storiesModal.querySelectorAll('[data-stories-prev]');
        var nextBtns = storiesModal.querySelectorAll('[data-stories-next]');
        var closeBtns = storiesModal.querySelectorAll('[data-stories-close]');
        var toggleBtn = storiesModal.querySelector('[data-stories-toggle]');
        var current = 0;
        var advanceHandler = null;

        /* Build one progress segment per slide. */
        slides.forEach(function () {
          var seg = document.createElement('span');
          seg.className = 'odday-stories-progress__seg';
          progressWrap.appendChild(seg);
        });
        var segments = Array.from(progressWrap.querySelectorAll('.odday-stories-progress__seg'));

        function show(i) {
          if (i < 0) i = 0;
          if (i >= slides.length) i = slides.length - 1;
          current = i;
          slides.forEach(function (s, idx) {
            s.classList.toggle('is-active', idx === i);
          });
          /* Reset progress: everything before current is done, current
             is active (animation restarts), everything after is empty.
             To restart the CSS animation we strip and re-add the class
             on the next frame so the browser re-evaluates it. */
          segments.forEach(function (seg, idx) {
            seg.classList.remove('is-active', 'is-done');
            if (idx < i) seg.classList.add('is-done');
          });
          /* Force reflow so removing-then-adding is-active triggers a
             new animation iteration. */
          /* eslint-disable-next-line no-unused-expressions */
          segments[i].offsetWidth;
          segments[i].classList.add('is-active');

          /* Listen for animation end on the current segment to advance. */
          if (advanceHandler) {
            segments.forEach(function (seg) { seg.removeEventListener('animationend', advanceHandler); });
          }
          advanceHandler = function (e) {
            if (e.target !== segments[current]) return;
            if (current < slides.length - 1) {
              show(current + 1);
            } else {
              close();
            }
          };
          segments[i].addEventListener('animationend', advanceHandler);
        }

        function open() {
          storiesModal.hidden = false;
          storiesModal.classList.add('is-open');
          storiesModal.classList.remove('is-paused');
          document.body.classList.add('odday-stories-open');
          show(0);
        }
        function close() {
          storiesModal.classList.remove('is-open');
          storiesModal.hidden = true;
          document.body.classList.remove('odday-stories-open');
          /* Stop progress animation by clearing the active class. */
          segments.forEach(function (seg) { seg.classList.remove('is-active'); });
        }
        function next() {
          if (current < slides.length - 1) show(current + 1);
          else close();
        }
        function prev() {
          if (current > 0) show(current - 1);
        }
        function togglePause() {
          var paused = storiesModal.classList.toggle('is-paused');
          if (toggleBtn) toggleBtn.setAttribute('aria-label', paused ? 'Play' : 'Pause');
        }

        storiesTrigger.addEventListener('click', open);
        closeBtns.forEach(function (b) { b.addEventListener('click', close); });
        prevBtns.forEach(function (b) { b.addEventListener('click', prev); });
        nextBtns.forEach(function (b) { b.addEventListener('click', next); });
        if (toggleBtn) toggleBtn.addEventListener('click', togglePause);

        /* Keyboard: arrows navigate, Esc closes, space toggles pause. */
        document.addEventListener('keydown', function (e) {
          if (!storiesModal.classList.contains('is-open')) return;
          if (e.key === 'Escape') { e.preventDefault(); close(); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
          else if (e.key === ' ') { e.preventDefault(); togglePause(); }
        });

        /* Clicking the dark backdrop (but not the frame or any control)
           closes the viewer, matching Instagram behavior. */
        storiesModal.addEventListener('click', function (e) {
          if (e.target === storiesModal) close();
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    /* Re-run when the theme editor re-renders the header section. The section
       element itself carries the .section-header class, so check both the
       target and its descendants — otherwise init() never re-runs after an
       editor edit and the injected drawer About/images disappear. */
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && (e.target.matches('.section-header') || e.target.querySelector('.section-header'))) init();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odday-faqs"] && !Shopify.designMode) return;
  try {
    
  /* Optional behaviour: only one FAQ open at a time. Enabled when the
     section sets data-single-open via a wrapper attribute on the
     parent — read via a class instead so it doesn't depend on attribute
     plumbing. Currently we let multiple be open; toggle below if desired. */
  (function () {
    /* Add scroll-into-view when an FAQ opens near the bottom of the
       viewport so the answer doesn't get cut off by the fold. */
    document.addEventListener('toggle', function (e) {
      var item = e.target;
      if (!item.matches || !item.matches('.odday-faq__item')) return;
      if (!item.open) return;
      var rect = item.getBoundingClientRect();
      if (rect.bottom > window.innerHeight - 80) {
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odday-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-odday-foot-review-open]');
      var modal = document.querySelector('[data-odday-foot-review]');
      if (!modal) return;
      if (open) {
        modal.hidden = false;
        modal.classList.add('is-open');
        document.body.classList.add('odday-foot-review-open');
        return;
      }
      var close = e.target.closest('[data-odday-foot-review-close]');
      if (close || e.target === modal) {
        modal.classList.remove('is-open');
        modal.hidden = true;
        document.body.classList.remove('odday-foot-review-open');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var modal = document.querySelector('[data-odday-foot-review]');
      if (!modal || !modal.classList.contains('is-open')) return;
      modal.classList.remove('is-open');
      modal.hidden = true;
      document.body.classList.remove('odday-foot-review-open');
    });
    /* If the form posted successfully, re-open so the user sees the success message. */
    if (window.location.hash === '#OddayFooterReviewForm') {
      var modal = document.querySelector('[data-odday-foot-review]');
      if (modal) {
        modal.hidden = false;
        modal.classList.add('is-open');
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odday-header"] && !Shopify.designMode) return;
  try {
    
  class OddayHeader extends HTMLElement {
    connectedCallback() {
      this.overlay = this.dataset.overlay === 'true';
      this.megaTimer = null;

      if (this.overlay) {
        this.onScroll = () => this.classList.toggle('is-solid', window.scrollY > 20);
        this.onScroll();
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }

      // Mega menu
      this.triggers = Array.from(this.querySelectorAll('[data-mega-trigger]'));
      this.mega = this.querySelector('[data-mega]');
      if (this.mega && this.triggers.length) {
        this.triggers.forEach((t) => {
          t.addEventListener('mouseenter', () => this.openMega());
          t.addEventListener('focusin', () => this.openMega());
        });
        this.mega.addEventListener('mouseenter', () => this.openMega());
        this.addEventListener('mouseleave', () => this.scheduleCloseMega());
      }

      // Mobile drawer — relocate to <body> so no ancestor can clip/offset it
      this.drawer = this.querySelector('[data-drawer]');
      if (this.drawer) {
        const id = this.drawer.dataset.drawerId;
        document.querySelectorAll('.odday-header__drawer[data-drawer-id="' + id + '"]').forEach((el) => { if (el !== this.drawer) el.remove(); });
        document.body.appendChild(this.drawer);
        this.movedDrawer = this.drawer;
        this.querySelectorAll('[data-drawer-toggle]').forEach((b) => b.addEventListener('click', () => this.openDrawer()));
        this.drawer.querySelectorAll('[data-drawer-close]').forEach((b) => b.addEventListener('click', () => this.closeDrawer()));
        this.onKey = (e) => { if (e.key === 'Escape') this.closeDrawer(); };
      }
    }
    disconnectedCallback() {
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.movedDrawer) this.movedDrawer.remove();
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onKey);
    }
    openMega() { clearTimeout(this.megaTimer); this.classList.add('is-mega-open'); if (this.overlay) this.classList.add('is-solid'); }
    scheduleCloseMega() {
      clearTimeout(this.megaTimer);
      this.megaTimer = setTimeout(() => {
        this.classList.remove('is-mega-open');
        if (this.overlay && window.scrollY <= 20) this.classList.remove('is-solid');
      }, 120);
    }
    openDrawer() {
      this.drawer.classList.add('is-open');
      const t = this.querySelector('[data-drawer-toggle]');
      if (t) t.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKey);
    }
    closeDrawer() {
      this.drawer.classList.remove('is-open');
      const t = this.querySelector('[data-drawer-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onKey);
    }
  }
  if (!customElements.get('odday-header')) customElements.define('odday-header', OddayHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odday-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class OddaySlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.odday-hero__slide'));
      this.panels = Array.from(this.querySelectorAll('.odday-hero__panel'));
      this.dots = Array.from(this.querySelectorAll('.odday-hero__dot'));
      this.counter = this.querySelector('[data-current]');
      this.index = 0;
      this.count = this.slides.length;

      /* Make sure only the active slide's video is playing; pause the rest. */
      this.syncVideos();

      if (this.count <= 1) return;

      this.querySelectorAll('[data-next]').forEach((b) => b.addEventListener('click', () => this.go(this.index + 1)));
      this.querySelectorAll('[data-prev]').forEach((b) => b.addEventListener('click', () => this.go(this.index - 1)));
      this.dots.forEach((d) => d.addEventListener('click', () => this.go(parseInt(d.dataset.goto, 10))));

      if (this.dataset.autoplay === 'true') {
        const speed = parseInt(this.dataset.speed, 10) || 5000;
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start(speed));
        this.start(speed);
      }
    }
    disconnectedCallback() { this.stop(); }
    start(speed) { this.stop(); this.timer = setInterval(() => this.go(this.index + 1), speed); }
    stop() { if (this.timer) clearInterval(this.timer); }
    syncVideos() {
      this.slides.forEach((s, n) => {
        const v = s.querySelector('video');
        if (!v) return;
        if (n === this.index) {
          const p = v.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
        } else {
          v.pause();
        }
      });
    }
    go(i) {
      this.index = (i + this.count) % this.count;
      this.slides.forEach((s, n) => s.classList.toggle('is-active', n === this.index));
      this.panels.forEach((p, n) => p.classList.toggle('is-active', n === this.index));
      this.dots.forEach((d, n) => d.classList.toggle('is-active', n === this.index));
      if (this.counter) this.counter.textContent = String(this.index + 1).padStart(2, '0');
      this.syncVideos();
    }
  }
  if (!customElements.get('odday-slideshow')) customElements.define('odday-slideshow', OddaySlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odday-instagram"] && !Shopify.designMode) return;
  try {
    
  class OddayDragCarousel extends HTMLElement {
    connectedCallback() {
      this.down = false; this.startX = 0; this.startScroll = 0; this.moved = 0;
      this.addEventListener('pointerdown', this.onDown);
      this.addEventListener('pointermove', this.onMove);
      this.addEventListener('pointerup', this.onUp);
      this.addEventListener('pointerleave', this.onUp);
      this.observeVideos();
    }

    disconnectedCallback() {
      if (this.videoObserver) this.videoObserver.disconnect();
    }

    /* Videos only load and play while their card is on screen — a dozen
       looping clips all running at once would tank the page. */
    observeVideos() {
      const videos = this.querySelectorAll('video');
      if (!videos.length || !('IntersectionObserver' in window)) return;
      this.videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              if (video.preload === 'none') video.preload = 'auto';
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.25 }
      );
      videos.forEach((v) => this.videoObserver.observe(v));
    }
    onDown = (e) => { this.down = true; this.moved = 0; this.startX = e.pageX; this.startScroll = this.scrollLeft; };
    onMove = (e) => {
      if (!this.down) return;
      const dx = e.pageX - this.startX;
      if (Math.abs(dx) > 4) this.classList.add('is-dragging');
      this.moved = Math.abs(dx);
      this.scrollLeft = this.startScroll - dx;
    };
    onUp = () => { this.down = false; setTimeout(() => this.classList.remove('is-dragging'), 0); };
  }
  if (!customElements.get('odday-drag-carousel')) customElements.define('odday-drag-carousel', OddayDragCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odday-others-also-bought"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.oddayOabInit) return;
      root.dataset.oddayOabInit = '1';

      var track = root.querySelector('[data-oab-track]');
      var prev = root.querySelector('[data-oab-prev]');
      var next = root.querySelector('[data-oab-next]');
      function scrollBy(dir) {
        if (!track) return;
        track.scrollBy({ left: dir * 280, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
      if (next) next.addEventListener('click', function () { scrollBy(1); });

      // Lazy-load product recommendations via section_id endpoint
      var recsUrl = root.dataset.recsUrl;
      if (recsUrl && track && !track.children.length) {
        // empty initial state — already shown skeleton; nothing more to do
      }
      if (recsUrl) {
        fetch(recsUrl)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-oab-track]');
            if (fresh && track) track.innerHTML = fresh.innerHTML;
          })
          .catch(function () { /* keep skeleton/empty */ });
      }
    }

    document.querySelectorAll('.odday-oab').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('.odday-oab');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odday-pre-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-odday-review-open]');
      if (openBtn) {
        var modal = document.querySelector('[data-odday-review]');
        if (modal) {
          modal.hidden = false;
          modal.classList.add('is-open');
          document.body.classList.add('odday-review-open');
        }
        return;
      }
      var closeBtn = e.target.closest('[data-odday-review-close]');
      var modal = document.querySelector('[data-odday-review]');
      if (!modal) return;
      /* Close on backdrop click or X button. Clicks inside the panel
         bubble up but are caught by .odday-review-modal__panel boundary. */
      if (closeBtn || e.target === modal) {
        modal.classList.remove('is-open');
        modal.hidden = true;
        document.body.classList.remove('odday-review-open');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var modal = document.querySelector('[data-odday-review]');
      if (!modal || !modal.classList.contains('is-open')) return;
      modal.classList.remove('is-open');
      modal.hidden = true;
      document.body.classList.remove('odday-review-open');
    });

    /* If the form posted successfully, Shopify re-renders the page with a
       hash. Re-open the modal so the user sees the success message. */
    if (window.location.hash === '#OddayReviewForm') {
      var modal = document.querySelector('[data-odday-review]');
      if (modal) {
        modal.hidden = false;
        modal.classList.add('is-open');
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odday-product-main"] && !Shopify.designMode) return;
  try {
    
  class OddayPdp extends HTMLElement {}
  // Lightweight controller — no shadow DOM, just per-section event wiring.
  (function () {
    function init(root) {
      if (!root || root.dataset.oddayPdpInit) return;
      root.dataset.oddayPdpInit = '1';

      var colorIndex = parseInt(root.dataset.colorIndex, 10);
      var sizeIndex = parseInt(root.dataset.sizeIndex, 10);

      // Mobile gallery
      var slides = root.querySelectorAll('[data-mobile-slide]');
      var thumbs = root.querySelectorAll('[data-mobile-thumb]');
      var prev = root.querySelector('[data-mobile-prev]');
      var next = root.querySelector('[data-mobile-next]');
      var current = 0;
      function setSlide(i) {
        if (i < 0) i = 0;
        if (i > slides.length - 1) i = slides.length - 1;
        current = i;
        slides.forEach(function (el, idx) { el.classList.toggle('is-active', idx === i); });
        thumbs.forEach(function (el, idx) { el.classList.toggle('is-active', idx === i); });
      }
      if (prev) prev.addEventListener('click', function () { setSlide(current - 1); });
      if (next) next.addEventListener('click', function () { setSlide(current + 1); });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { setSlide(parseInt(t.dataset.index, 10)); });
      });

      // Size selection
      var sizeBtns = root.querySelectorAll('[data-size-btn]');
      var sizeLabel = root.querySelector('[data-size-label]');
      var variantInput = root.querySelector('[data-variant-input]');
      var sizeError = root.querySelector('[data-size-error]');
      var addBtn = root.querySelector('[data-add-btn]');
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare]');
      var discountEl = root.querySelector('[data-discount]');

      function setActiveSize(btn) {
        sizeBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (sizeLabel) sizeLabel.textContent = btn.dataset.sizeValue;
        if (variantInput) variantInput.value = btn.dataset.variantId;
        if (sizeError) sizeError.hidden = true;
        // Sync URL ?variant=
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', btn.dataset.variantId);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
      sizeBtns.forEach(function (btn) {
        if (btn.disabled) return;
        btn.addEventListener('click', function () { setActiveSize(btn); });
      });

      // Add to cart — show success state inline
      var form = root.querySelector('form[action*="/cart/add"]');
      if (form) {
        form.addEventListener('submit', function (e) {
          // Guard: size required if a size option exists
          if (sizeIndex >= 0) {
            var anyActive = root.querySelector('[data-size-btn].is-active');
            if (!anyActive) {
              e.preventDefault();
              if (sizeError) sizeError.hidden = false;
              return;
            }
          }
          // Try AJAX cart add; fall back to native submit if /cart/add.js is unavailable
          if (window.fetch) {
            e.preventDefault();
            var fd = new FormData(form);
            addBtn.disabled = true;
            fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
              method: 'POST',
              body: fd,
              headers: { Accept: 'application/json' }
            })
              .then(function (r) { return r.json(); })
              .then(function () {
                addBtn.classList.add('is-added');
                var def = addBtn.querySelector('[data-add-default]');
                var ok = addBtn.querySelector('[data-add-success]');
                if (def) def.hidden = true;
                if (ok) ok.hidden = false;
                document.dispatchEvent(new CustomEvent('cart:updated'));
                setTimeout(function () {
                  addBtn.classList.remove('is-added');
                  if (def) def.hidden = false;
                  if (ok) ok.hidden = true;
                  addBtn.disabled = false;
                }, 2500);
              })
              .catch(function () {
                addBtn.disabled = false;
                form.submit();
              });
          }
        });
      }

      // Accordions
      root.querySelectorAll('[data-acc-trigger]').forEach(function (t) {
        t.addEventListener('click', function () {
          var body = document.getElementById(t.getAttribute('aria-controls'));
          var open = t.getAttribute('aria-expanded') === 'true';
          t.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (body) body.hidden = open;
        });
      });

      // Track recently viewed (handle list in localStorage, used by odday-recently-viewed)
      try {
        var handle = root.dataset.productHandle;
        if (handle) {
          var key = 'odday:recently-viewed';
          var list = JSON.parse(localStorage.getItem(key) || '[]');
          list = list.filter(function (h) { return h !== handle; });
          list.unshift(handle);
          if (list.length > 12) list = list.slice(0, 12);
          localStorage.setItem(key, JSON.stringify(list));
        }
      } catch (e) {}
    }

    document.querySelectorAll('[data-pdp]').forEach(init);
    // Shopify section re-render after editor save
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-pdp]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odday-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.oddayRvInit) return;
      root.dataset.oddayRvInit = '1';

      var current = root.dataset.currentHandle || '';
      var limit = parseInt(root.dataset.limit, 10) || 4;
      var inner = root.querySelector('.odday-rv__inner');
      var grid = root.querySelector('[data-rv-grid]');

      var key = 'odday:recently-viewed';
      var handles = [];
      try { handles = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) {}
      handles = handles.filter(function (h) { return h && h !== current; }).slice(0, limit);
      if (!handles.length) return;

      function money(cents) {
        try {
          var locale = (document.documentElement.lang || 'en').replace('_', '-');
          var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
          return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, maximumFractionDigits: 0 }).format(cents / 100);
        } catch (e) {
          return (cents / 100).toFixed(0);
        }
      }

      Promise.all(handles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) {
          if (!r.ok) throw new Error('not found');
          return r.json();
        }).catch(function () { return null; });
      })).then(function (products) {
        products = products.filter(Boolean);
        if (!products.length) return;
        var html = products.map(function (p) {
          var img = (p.featured_image || (p.images && p.images[0]) || '');
          var hover = p.images && p.images[1] ? p.images[1] : '';
          var compare = p.compare_at_price_min > p.price_min;
          return ''
            + '<a href="' + p.url + '" class="odday-rv__card">'
            +   '<div class="odday-rv__card-media">'
            +     (img ? '<img class="odday-rv__card-img" src="' + img + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '')
            +     (hover ? '<img class="odday-rv__card-hover" src="' + hover + '" alt="" loading="lazy">' : '')
            +   '</div>'
            +   '<h3 class="odday-rv__card-name">' + p.title + '</h3>'
            +   '<div class="odday-rv__card-prices">'
            +     '<span class="odday-rv__card-price">' + money(p.price) + '</span>'
            +     (compare ? '<span class="odday-rv__card-compare">' + money(p.compare_at_price) + '</span>' : '')
            +   '</div>'
            + '</a>';
        }).join('');
        grid.innerHTML = html;
        inner.hidden = false;
      });
    }

    document.querySelectorAll('[data-rv]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-rv]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odday-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.oddayStlInit) return;
      root.dataset.oddayStlInit = '1';

      var stage = root.querySelector('[data-stage]');
      var dots = root.querySelectorAll('[data-hotspot]');
      var listTriggers = root.querySelectorAll('[data-list-trigger]');
      var panelDefault = root.querySelector('[data-panel-default]');
      var panelActive = root.querySelector('[data-panel-active]');
      var activeImg = root.querySelector('[data-active-img]');
      var activeName = root.querySelector('[data-active-name]');
      var activePrice = root.querySelector('[data-active-price]');
      var activeLink = root.querySelector('[data-active-link]');
      var activeCta = root.querySelector('[data-active-cta]');

      var activeId = null;

      function setActive(id) {
        activeId = id;
        if (!id) {
          dots.forEach(function (d) { d.classList.remove('is-active'); });
          if (panelDefault) panelDefault.hidden = false;
          if (panelActive) panelActive.hidden = true;
          return;
        }
        var btn = root.querySelector('[data-hotspot][data-id="' + id + '"]');
        if (!btn) return;
        dots.forEach(function (d) { d.classList.toggle('is-active', d === btn); });
        if (activeImg) {
          activeImg.src = btn.dataset.image || '';
          activeImg.alt = btn.dataset.name || '';
        }
        if (activeName) activeName.textContent = btn.dataset.name || '';
        if (activePrice) activePrice.textContent = btn.dataset.price || '';
        if (activeLink) activeLink.href = btn.dataset.url || '#';
        if (activeCta) activeCta.href = btn.dataset.url || '#';
        if (panelDefault) panelDefault.hidden = true;
        if (panelActive) panelActive.hidden = false;
      }

      dots.forEach(function (btn) {
        btn.addEventListener('click', function () { setActive(activeId === btn.dataset.id ? null : btn.dataset.id); });
        btn.addEventListener('mouseenter', function () { setActive(btn.dataset.id); });
        btn.addEventListener('focus', function () { setActive(btn.dataset.id); });
      });
      if (stage) stage.addEventListener('mouseleave', function () { /* keep selected on desktop */ });

      listTriggers.forEach(function (b) {
        b.addEventListener('click', function () { setActive(b.dataset.id); });
      });
    }

    document.querySelectorAll('[data-stl]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-stl]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odday-stats-bar"] && !Shopify.designMode) return;
  try {
    
  class OddayCounter extends HTMLElement {
    connectedCallback() {
      /* Underscore-prefixed because `Element.prefix` is a built-in read-only
         getter (XML namespace prefix). Assigning `this.prefix` throws
         "Cannot set property prefix of #<Element> which has only a getter".
         Renaming the rest for consistency. */
      this._value = parseFloat(this.dataset.value) || 0;
      this._prefix = this.dataset.prefix || '';
      this._suffix = this.dataset.suffix || '';
      this._duration = parseInt(this.dataset.duration, 10) || 2000;
      this.hasRun = false;

      /* If the value is 0 (or missing) there's nothing to count up to — show
         it as-is instead of leaving an animation observer hanging. */
      if (!this._value) { this.render(0); return; }

      const fire = () => {
        if (this.hasRun) return;
        this.hasRun = true;
        if (this.observer) this.observer.disconnect();
        if (this.fallback) clearTimeout(this.fallback);
        this.run();
      };

      if ('IntersectionObserver' in window) {
        /* threshold 0.1 — 0.5 was too strict for tall stat sections on short
           viewports, leaving the counter stuck at 0 because intersection
           never crossed 50%. */
        this.observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) fire();
        }, { threshold: 0.1 });
        this.observer.observe(this);

        /* Safety net: Shopify's theme-editor iframe and some sticky-header
           layouts can prevent IntersectionObserver from ever reporting an
           intersection. Fire after ~1.5s no matter what so the final value
           always lands on screen. If the user genuinely never scrolls here
           the animation just plays off-screen — no harm. */
        this.fallback = setTimeout(fire, 1500);
      } else {
        fire();
      }
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.fallback) clearTimeout(this.fallback);
    }
    run() {
      const start = performance.now();
      const tick = (now) => {
        const p = Math.min((now - start) / this._duration, 1);
        const eased = 1 - Math.pow(1 - p, 3);
        this.render(Math.floor(eased * this._value));
        if (p < 1) requestAnimationFrame(tick); else this.render(this._value);
      };
      requestAnimationFrame(tick);
    }
    render(n) { this.textContent = this._prefix + n.toLocaleString() + this._suffix; }
  }
  if (!customElements.get('odday-counter')) customElements.define('odday-counter', OddayCounter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odday-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  class OddayStickyAtc extends HTMLElement {
    connectedCallback() {
      this.addButton = this.querySelector('[data-satc-add]');
      this.labelEl = this.querySelector('[data-satc-label]');
      this.priceEl = this.querySelector('[data-satc-price]');
      this.thumbEl = this.querySelector('[data-satc-thumb]');
      this.offset = parseInt(this.dataset.offset, 10) || 0;

      // Cache the last mirrored values so re-syncs don't touch the DOM needlessly.
      this.lastPrice = '';
      this.lastLabel = '';

      this.addButton.addEventListener('click', this.onClick);
      this.sync();

      // The product section re-renders its price/button on every variant change,
      // which replaces the very nodes we mirror — re-resolve them when it does.
      var host = this.productSection();
      if (host && 'MutationObserver' in window) {
        this.domObserver = new MutationObserver(this.queueSync);
        this.domObserver.observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });
      }
      document.addEventListener('shopify:section:load', this.queueSync);
    }

    disconnectedCallback() {
      if (this.domObserver) this.domObserver.disconnect();
      if (this.visibilityObserver) this.visibilityObserver.disconnect();
      document.removeEventListener('shopify:section:load', this.queueSync);
    }

    productSection() {
      return document.querySelector('product-info') || document.querySelector('[data-pdp]') || document.querySelector('.product');
    }

    /* The real submit button — never one of ours, and never a quick-add card's. */
    realAddButton() {
      var buttons = document.querySelectorAll('form[action*="/cart/add"] [name="add"]');
      for (var i = 0; i < buttons.length; i++) {
        if (!buttons[i].closest('odday-sticky-atc') && !buttons[i].closest('quick-add-modal, .card-wrapper')) {
          return buttons[i];
        }
      }
      return null;
    }

    queueSync = () => {
      if (this.syncQueued) return;
      this.syncQueued = true;
      requestAnimationFrame(() => {
        this.syncQueued = false;
        this.sync();
      });
    };

    sync() {
      var real = this.realAddButton();

      // No product form on the page (or it was removed) — keep the bar down.
      if (!real) {
        this.hide();
        return;
      }

      // Mirror label and availability from the real button.
      var label = (real.querySelector('span:not(.visually-hidden)') || real).textContent.trim();
      if (label && label !== this.lastLabel) {
        this.labelEl.textContent = label;
        this.lastLabel = label;
      }
      this.addButton.disabled = real.disabled;

      // Mirror price markup from the theme's own price block.
      var host = this.productSection();
      var price = host && (host.querySelector('[id^="price-"]') || host.querySelector('.price'));
      if (price && price.innerHTML !== this.lastPrice) {
        this.priceEl.innerHTML = price.innerHTML;
        this.lastPrice = price.innerHTML;
      }

      // Follow the gallery's current image so variant swaps stay in sync.
      if (this.thumbEl && host) {
        var img = host.querySelector('.product__media img, .product-media img, [data-pdp] .odday-pdp__main-img');
        if (img && img.currentSrc && img.currentSrc !== this.thumbEl.src) this.thumbEl.src = img.currentSrc;
      }

      this.watch(real);
    }

    /* Reveal the bar once the real button has scrolled up out of view. */
    watch(real) {
      if (this.watched === real) return;
      this.watched = real;
      if (this.visibilityObserver) this.visibilityObserver.disconnect();

      if (!('IntersectionObserver' in window)) {
        this.show();
        return;
      }
      this.visibilityObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting && entry.boundingClientRect.top < 0) this.show();
            else this.hide();
          });
        },
        { rootMargin: this.offset + 'px 0px 0px 0px', threshold: 0 }
      );
      this.visibilityObserver.observe(real);
    }

    show() {
      this.classList.add('is-visible');
      this.setAttribute('aria-hidden', 'false');
    }

    hide() {
      this.classList.remove('is-visible');
      this.setAttribute('aria-hidden', 'true');
    }

    onClick = () => {
      var real = this.realAddButton();
      if (!real || real.disabled) return;
      // Hand off to the theme: this runs its validation, AJAX add, and cart drawer.
      real.click();
      // If the theme scrolls to an unselected option or shows an inline error,
      // it does so inside the product section — bring it into view.
      var host = this.productSection();
      if (host && host.querySelector('.product-form__error-message-wrapper:not([hidden])')) {
        host.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };
  }

  if (!customElements.get('odday-sticky-atc')) customElements.define('odday-sticky-atc', OddayStickyAtc);

  } catch(e) { console.error(e); }
})();
})();
